import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  OutlinedInput,
} from "@mui/material";

import { isValidArray } from "utils/array";
import { useGetPhysiciansQuery } from "app/store/transmission/api/transmissionTableApi";

const AssignedPhysiciansInput = ({
  fields,
  onUpdate,
  label = "Assigned Physician",
}) => {
  const { data: physicianData } = useGetPhysiciansQuery({
    isPhysicianModal: true,
    active: true,
  });

  return (
    <FormControl fullWidth variant="outlined" margin="none" required>
      <InputLabel id="select-assigned-physician">{label}</InputLabel>
      <Select
        labelId="select-assigned-physician"
        variant="outlined"
        margin="none"
        value={fields.assignedPhysician}
        onChange={(e) => {
          onUpdate({ assignedPhysician: e.target.value });
        }}
        input={<OutlinedInput id="multiple-chip" label={label} />}
      >
        {isValidArray(physicianData) ? (
          physicianData.map((physician, index) => (
            <MenuItem key={index} value={physician?.userId}>
              {physician.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            No physicians available under the selected account.
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default AssignedPhysiciansInput;
